import { toast } from 'react-toastify';

const toastOptions = {
    autoClose: false,
    closeButton: false,
    closeOnClick: true,
    hideProgressBar: true,
    draggable: false,
    draggablePercent: 0,
    className: 'toast-container'
};

const toastErrorOptions = {
    ...toastOptions,
    autoClose: 5000
};

const toastSuccessOptions = {
    ...toastOptions,
    autoClose: 5000
};
export const success = (component, options = {}) =>
    toast.success(component, { ...toastSuccessOptions, ...options });
export const info = (component, options = {}) =>
    toast.info(component, { ...toastSuccessOptions, ...options });
export const error = (component, options = {}) =>
    toast.error(component, { ...toastErrorOptions, ...options });
export const warning = (component, options = {}) =>
    toast.warning(component, { ...toastOptions, ...options });

export const dismissAll = () => toast.dismiss();
export default {
    success,
    info,
    error,
    warning,
    dismissAll
};
